// Una sola pasarela está activa a la vez (Stripe XOR Redsys).
// Cuando confirmes el campo exacto que devuelve cargarFuncionalidades / lmsActivo
// para la pasarela, basta con tocar PASARELA_FIELD en el hook usePasarelaActiva.

export const PASARELAS = {
  STRIPE: 'stripe',
  REDSYS: 'redsys',
};

// Texto que aparece al usuario y, por convención, el valor que el backend
// devuelve en Forma_de_pago de los recibos. Si Redsys llega con otro casing,
// se ajusta solo aquí.
export const labelPasarela = (pasarela) => {
  if (pasarela === PASARELAS.REDSYS) return 'Redsys';
  return 'Stripe';
};

export const isPasarelaPago = (pasarela) =>
  pasarela === PASARELAS.STRIPE || pasarela === PASARELAS.REDSYS;
